export default "/images/vendor/@coreui/icons/svg/flag/cif-pl.svg?8ad671f36707eabc7959768ae8fedadc";